import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_SERVICE,
  SAVE_SERVICE_SUCCESS,
  SAVE_SERVICE_FAILURE,
  ADD_SERVICE_TO_THE_LIST,
  UPDATE_SERVICE_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-SERVICE--->>>
export const saveServiceInProgress = createAction(SAVE_SERVICE);
export const saveServiceSuccess = createAction(SAVE_SERVICE_SUCCESS);
export const addServiceToTheList = createAction(ADD_SERVICE_TO_THE_LIST);
export const saveServiceFailure = createAction(SAVE_SERVICE_FAILURE);

export const saveService = (formData, lang, callback) => async dispatch => {
  dispatch(saveServiceInProgress());
  try {
    const res = await api.post(`service/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(saveServiceSuccess(data));
    dispatch(addServiceToTheList(data));
  } catch (error) {
    dispatch(saveServiceFailure(error));
  }
};

//<<<---UPDATE-SERVICE--->>>
export const updateServiceInTheList = createAction(UPDATE_SERVICE_IN_THE_LIST);

export const updateService = (
  formData,
  id,
  lang,
  callback
) => async dispatch => {
  dispatch(saveServiceInProgress());
  try {
    const res = await api.post(`service/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(saveServiceSuccess(data));
    dispatch(updateServiceInTheList(data));
  } catch (error) {
    dispatch(saveServiceFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () => change(formName, fieldName, {});


// WEBPACK FOOTER //
// ./src/modules/ServiceForm/actions.js